import React from 'react';
import { BOX_MOCKUP, BOX_MOCKUP_ALT } from '../../data/site';
export function HeroMockup() {
  return <div className="mx-auto w-full max-w-[420px] sm:max-w-[480px] lg:max-w-[540px]" data-id="element-124" data-mp="q0as1z71fkjw">
      <img src={BOX_MOCKUP} alt={BOX_MOCKUP_ALT} width={1374} height={1145} className="block h-auto w-full drop-shadow-[0_24px_32px_rgba(0,0,0,0.55)]" data-id="element-125" data-mp="c95z1fy6dqij" />
      <p className="mx-auto mt-5 w-fit rounded-full border border-gold/50 bg-forest px-4 py-1.5 text-center text-[11.5px] font-bold uppercase tracking-[0.16em] text-gold sm:mt-6 sm:text-[13px]" data-id="element-126" data-mp="29yo0zewy7yl">
        Lesson plans + 5 bonuses · Digital PDF
      </p>
    </div>;
}